import React, { useEffect, useState } from "react";
import LabeledInput from "../ui/LabeledInput";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import OTPInput from "react-otp-input";
import { apiPost } from "../api/request";
import apiRoutes from "../api/apiRoutes";
import useAuthStore from "../store/authStore";
import { toast } from "react-toastify";
import SignInButton from "../components/SigninButton";

export default function LoginPage() {
  const { login } = useAuthStore();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [showOtpForm, setShowOtpForm] = useState(false);
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const response = await apiPost(apiRoutes.login, formData);
      console.log("Login Status:", response);

      // If login is successful, move to OTP form
      // if (data.success) {
      //   setShowOtpForm(true);
      // }

      if (response.status === 200) {
        const { token, user } = response.data;
        // Save user data and token globally
        login(user, token);
        console.log("Login data.success:", response.user);
        toast.success("Login successful!");
        navigate("/dashboard/home");
      }
    } catch (err) {
      console.error("Login Error:", err.message);
      toast.error(err.message);
    }
  };

  const handleResend = () => {
    console.log("Resend OTP triggered");
    // API call for resend can be added here
  };

  const handleOTPSubmit = () => {
    // You can add OTP validation logic here
    navigate("/dashboard");
  };

  return (
    <div className="min-h-screen flex">
      {/* Left Panel */}
      <div className="w-[60%] bg-black text-white relative overflow-hidden rounded-t-[1.5rem] m-2 rounded-b-[1.5rem]">
        <img
          src="minimalist-photorealistic-urban-road.jpg"
          alt="Background"
          className="absolute inset-0 w-full h-full object-cover opacity-80"
        />
        <div className="relative z-10 p-6 flex flex-col justify-between h-full">
          <div className="flex justify-between items-center">
            <h2 className="text-lg font-semibold">Motor Vehicles Law</h2>
          </div>
        </div>
      </div>

      {/* Right Panel */}
      <div className="w-[40%] flex items-center justify-center bg-white rounded-tl-[3rem] rounded-bl-[3rem] relative">
        <div className="w-3/4 max-w-sm">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-xl font-bold">Motor Vehicles Law</h1>
          </div>
          <h2 className="text-2xl font-bold mb-2">Hello Administrator</h2>
          <p className="text-gray-500 mb-6">Welcome to E Book Console</p>

          <AnimatePresence mode="wait">
            {!showOtpForm ? (
              <motion.form
                key="login"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.3 }}
                onSubmit={(e) => {
                  e.preventDefault();
                  // setShowOtpForm(true);
                  handleLogin();
                }}
              >
                <LabeledInput
                  id="email"
                  label="Email"
                  placeholder="Enter Email"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData((prev) => ({ ...prev, email: e.target.value }))
                  }
                  className="w-full px-4 py-2 my-1 border rounded-md text-sm"
                />

                <LabeledInput
                  id="password"
                  label="Password"
                  placeholder="Enter Password"
                  value={formData.password}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      password: e.target.value,
                    }))
                  }
                  className="tw-full px-4 py-2 my-1 border rounded-md text-sm"
                />
                <div className="text-right mb-4">
                  <a href="#" className="text-xs text-black hover:underline">
                    Forgot password?
                  </a>
                </div>
                <button
                  type="submit"
                  className="w-full py-3 my-[20px] text-sm bg-black text-white font-regular py-2 rounded-[5px]"
                >
                  Login
                </button>
                {/* Read Book Button */}
                <p className="text-center text-xs text-gray-500 mt-4">
                  Would you like to read a book from the platform?{" "}
                  <a href="#" className="text-yellow-600 hover:underline">
                    Read Book Now!
                  </a>
                </p>
              </motion.form>
            ) : (
              <motion.form
                key="otp"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.3 }}
                onSubmit={(e) => {
                  e.preventDefault();
                  console.log("OTP submitted:", otp);
                }}
              >
                <label className="block mb-2 mx-1 text-sm font-medium text-gray-700">
                  Enter OTP
                </label>
                <OTPInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={6}
                  renderInput={(props) => <input {...props} />}
                  inputStyle={{
                    width: "2.5rem",
                    height: "2.5rem",
                    margin: "0 0.25rem",
                    fontSize: "1.25rem",
                    borderRadius: "0.375rem",
                    border: "1px solid #ccc",
                  }}
                  containerStyle="flex justify-between mb-4"
                />

                <div className="text-sm text-right mb-4">
                  <button
                    type="button"
                    onClick={handleResend}
                    className="text-yellow-600 hover:underline"
                  >
                    Resend OTP
                  </button>
                </div>

                <div className="grid grid-cols-2 gap-3 mt-2">
                  <button
                    type="button"
                    onClick={() => setShowOtpForm(false)}
                    className="w-full py-3 my-[20px] border border-black text-sm text-black font-regular py-2 rounded-[5px]"
                  >
                    Back
                  </button>

                  <button
                    type="submit"
                    onClick={() => handleOTPSubmit()}
                    className="w-full py-3 my-[20px] bg-black text-white text-sm font-regular py-2 rounded-[5px]"
                  >
                    Verify OTP
                  </button>
                </div>
              </motion.form>
            )}
          </AnimatePresence>

          {/* Social Icons */}
          <div className="flex justify-center space-x-4 mt-6 text-gray-400">
            <a href="#">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="#">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="#">
              <i className="fab fa-instagram"></i>
            </a>
          </div>

          {/* Footer Attribution */}
          <div className="absolute ml-[20px] bottom-4 transform text-center text-xs text-gray-400">
            Powered by{" "}
            <a
              href="https://www.teqbae.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-red-500 hover:underline"
            >
              Teqbae
            </a>
            <span> Innovations & Solutions India Pvt Ltd.</span>
          </div>
        </div>
      </div>
    </div>
  );
}
